import app from './zh-CN/app';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';

export default {
  ...app,
  ...menu,
  ...pages,
};
